let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("846i1")).then(() => parcelRequire('ibNjJ'));